import { fetchFile, createFFmpeg } from '@ffmpeg/ffmpeg';
import { v4 as uuidv4 } from 'uuid';
import { getInfo } from 'react-mediainfo';
let fileCreateObjectURL;
let videoMedia = {};
// 全局创建转码器实例
let ffmpegInstance;
let isExit = true;
let _callback;
export const videoTranscode = async (uploadFile, callback) => {
  _callback = callback;
  if (fileCreateObjectURL) {
    URL.revokeObjectURL(fileCreateObjectURL);
    fileCreateObjectURL = '';
  }
  // 文件转blob用于网页播放
  fileCreateObjectURL = URL.createObjectURL(uploadFile);
  try {
    const isLoader = await isLoadedSuccess(fileCreateObjectURL, uploadFile);
    if (isLoader) {
      // // 可以正常播放
      videoMedia.canPlay = isLoader;
      if (videoMedia.canPlay) {
        const loadMetaSuccess = await loadMeta(fileCreateObjectURL, uploadFile);
        // 转码成功是否能播放
        // if (fileCreateObjectURL) {
        //   URL.revokeObjectURL(fileCreateObjectURL);
        //   fileCreateObjectURL = '';
        // }
        return loadMetaSuccess;
      }
    } else {
      // 需要转码
      _callback({
        needTranscode: true,
        fromPage: 'upload',
        transcodeState: '',
        transcodeProgress: 0,
      });
      let isTranscodeSuccess = await videoTranscodeHandler(uploadFile);
      if (isTranscodeSuccess.result) {
        // 转码成功
        const loadMetaSuccess = await loadMeta(
          isTranscodeSuccess.videoUrl,
          isTranscodeSuccess.transcodeFile
        );
        // if (fileCreateObjectURL) {
        //   URL.revokeObjectURL(fileCreateObjectURL);
        //   fileCreateObjectURL = '';
        // }
        // 转码成功是否能播放
        return loadMetaSuccess;
      } else {
        // 转码失败
        return {
          type: 'fileTranscodeFailure', // 装码失败
          result: isTranscodeSuccess.result,
        };
      }
    }
  } catch (error) {
    return {
      type: 'filePlayFailure', // 播放失败
      result: false,
    };
  }
};

/**
 * 判断视频是否可以正常播放
 * @param blobUrl blob格式url（ 用户上传的视频 ）
 */
const isLoadedSuccess = (blobUrl, uploadFile) => {
  return new Promise((resolve, reject) => {
    const videoCont = document.createElement('video');
    videoCont.setAttribute('src', blobUrl);
    videoCont.load();
    // 非视频文件加载报错
    videoCont.addEventListener('error', (e) => {
      resolve(false);
    });
    videoCont.addEventListener('loadedmetadata', (e) => {
      // 时长异常的情况抛文件错误
      if (videoCont.duration == Infinity) {
        reject();
      } else if (videoCont.videoWidth && videoCont.videoHeight) {
        // 多种条件判断是否转码
        mediaInfo(uploadFile).then((res) => {
          if (res && Array.isArray(res)) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      } else {
        resolve(false);
      }
    });
  });
};

// 所有格式文件统一处理loadedmetadata
const loadMeta = (url, uploadFile) => {
  return new Promise((resolve, reject) => {
    let video = document.createElement('video');
    video.src = url;
    // document.appendChild(video);
    video.addEventListener('error', (e) => {
      resolve({
        type: 'fileTranscodeFailure', //转码失败
        result: false,
      });
    });
    video.addEventListener('loadedmetadata', () => {
      // 没有视频的情况也会经历转码，转码过后导致编辑页异常，加一层判断
      let invalidResult = video.videoWidth && video.videoHeight;
      if (invalidResult) {
        // 正常剪辑
        videoMedia.duration = video.duration;
        videoMedia.height = video.videoHeight;
        videoMedia.width = video.videoWidth;
        // document.removeChild(video); //将a从页面上删除
        resolve({
          type: 'filePlaySuccess', // 播放成功
          uploadFile: uploadFile,
          result: true,
        });
      } else {
        document.removeChild(video); //将a从页面上删除
        resolve({
          type: 'filePlayFailure', // 播放失败
          result: false,
        });
      }
    });
  });
};

// 转码
const videoTranscodeHandler = async (uploadFile) => {
  return new Promise((resolve, reject) => {
    if (isExit) {
      ffmpegInstance = createFFmpeg({
        log: false,
        threads: 4,
      });
      isExit = false;
    }
    let realFileName = uploadFile.name.substr(
      0,
      uploadFile.name.lastIndexOf('.')
    );
    console.time('videoTranscode');
    const uuidFileName = uuidv4();
    videoTranscodeFunc(ffmpegInstance, uploadFile, uuidFileName).then(() => {
      console.log('开始转码');
      let name = uuidFileName;
      // 转码进度
      let curProgress = 0; // 进度取值不稳定，作为对比
      let startTranscode = false;
      let progressCounter = 0;
      ffmpegInstance.setProgress(({ ratio }) => {
        // 开始转码时跳转到进度页，只执行一次
        // 看是否进度也，没有进度页还是保持在上传页中
        if (!startTranscode) {
          startTranscode = true;
        }
        // ratio is a float number between 0 to 1.
        // ratio可能小于0或者大于1，需要处理
        if (ratio > 0) {
          let progress = parseInt(ratio * 100 + ''); //转为两位数
          if (progress < 100) {
            if (progressCounter === 0 && progress > 90) return; // 规避转码异常
            curProgress = Math.max(curProgress, progress); //取相对更大的值，避免进度倒着走
            curProgress = curProgress < 1 ? 1 : curProgress; // 大文件转码初始进度0.00X，出现长时间为0的情况优化
            // 转码进度抛出去
            _callback({
              needTranscode: true,
              fromPage: 'upload',
              transcodeState: '',
              transcodeProgress: curProgress,
            });
            progressCounter++;
          }
        }
      });

      // 通过文件格式校验的，在解析时也加一层拦截，检查异常文件，报错中断
      ffmpegInstance.setLogger(({ type, message }) => {
        // 异常情况判断
        let invalidMessage = ['Conversion failed!', 'pthread sent an error!'];
        let invalid = invalidMessage.some((item) => message.includes(item));
        if (type === 'fferr' && invalid) {
          // 解析后仍无法操作的情况
          resolve({
            type: 'fileTranscodeFailure', // 转码失败
            result: false,
          });
        }

        // 转码结束处理
        if (type === 'ffout') {
          try {
            const data = ffmpegInstance.FS('readFile', `${name}.mp4`);
            console.timeEnd('videoTranscode');
            let videoUrl = '';
            videoUrl = URL.createObjectURL(
              new Blob([data.buffer], { type: 'video/mp4' })
            );

            // 将转换完成的文件进行重建
            // 这里使用realFileName，即文件真实名称，用于下载
            var result = new File([data.buffer], `${realFileName}.mp4`, {
              type: 'video/mp4',
              lastModified: Date.now(),
            });
            // uploadFile.size = result.size;
            // uploadFile.raw = result;
            // uploadFile.status = 'ready';
            // 防止ffmpeg返回值异常，只在结束时才赋值100
            // percentage.value = 100;
            _callback({
              needTranscode: true,
              fromPage: 'upload',
              transcodeState: '',
              transcodeProgress: 100,
            });
            // 转码进度抛出去
            resolve({
              type: 'fileTranscodeSuccess', // 转码成功
              result: true,
              videoUrl,
              transcodeFile: result,
            });
            ffmpegInstance.FS('unlink', `${name}.mp4`); // 释放内存中的文件
            setTimeout(() => {
              exit();
            }, 1000);
          } catch (err) {
            console.log('转码失败', err);
            setTimeout(() => {
              exit();
            }, 1000);
            resolve({
              type: 'fileTranscodeFailure', // 转码失败,
              result: false,
            });
          }
        }
      });
    });
  });
};

export const videoTranscodeFunc = async (ffmpeg, file, name) => {
  try {
    if (!ffmpeg.isLoaded()) await ffmpeg.load(); // load过的不需要重复load，否则会转码失败
    // console.log('1', name, `${name}.mp4`);
    ffmpeg.FS('writeFile', name, await fetchFile(file));
    // console.log('2', name, `${name}.mp4`);
    const run = await mediaInfo(file);
    if (run && Array.isArray(run)) {
      ffmpeg.run('-i', name, ...run, `${name}.mp4`);
    } else {
      ffmpeg.run('-i', name, `${name}.mp4`);
    }
    // -max_muxing_queue_size 1024 -crf 28 -r 30 -c:v libx264 -preset faster -threads 0 -y
  } catch (err) {
    //console.log('ffmpeg run error', err);
  }
};

export const exit = () => {
  isExit = true;
  setTimeout(() => {
    try {
      ffmpegInstance && ffmpegInstance.exit();
    } catch (error) {
      console.log('vvv');
    } finally {
      ffmpegInstance = '';
    }
  }, 100);
};

const mediaInfo = (file) => {
  //   // 视频的分辨率长或高不是偶数。
  //   // 视频的帧率超过60。
  return new Promise((resolve, reject) => {
    getInfo(file).then((obj) => {
      let runString = [];
      if (!!obj.media.track[0].FrameRate) {
        // let rate = {
        //     frameRate: +obj.media.track[0].FrameRate,
        //     bitRate: Math.floor(obj.media.track[1].BitRate),
        // };
        // this.props.onSaveFrameRate(rate);
        const width = parseInt(obj.media.track[1].Width);
        const height = parseInt(obj.media.track[1].Height);
        const FrameRate = parseInt(obj.media.track[1].FrameRate);
        if (width % 2 !== 0 || height % 2 !== 0) {
          runString.push('-vf');
          runString.push(
            `scale=${width % 2 !== 0 ? width + 1 : width}*${
              height % 2 !== 0 ? height + 1 : height
            }`
          );
        }
        if (FrameRate > 60) {
          runString.push('-r');
          runString.push(`${FrameRate > 60 ? 60 : FrameRate}`);
        }
      }
      if (runString.length >= 1) {
        resolve(runString);
      } else {
        resolve(true);
      }
    });
  });
};
